// extracted by mini-css-extract-plugin
module.exports = {"categories":"hero_categories__3qTwv","illustrationWrapper":"hero_illustrationWrapper__bmvPU","text":"hero_text__5R3xS","foreground":"hero_foreground__O_4GB"};